export const sdkDebuggerRecordingIdLogs = "/sdk/debugger/:recording_id/logs";
